import client from './api-client';

export const getConfiguracionForm43 = async(query) => {
    try {
        
        const response = await client.getImplicado(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form43: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getDatosGestionImpicado = async(query) => {
    try {
        
        const response = await client.getImplicado(`getion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestionImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getListaImplicado = async(query) => {
    try {
        
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getTareasPendientes = async(query) => {
    try {
        
        const response = await client.get(`tareas-defensa?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaTareasPendientes: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaPretensionesImplicados = async(query) => {
    try {
        
        const response = await client.getImplicado(`pretensiones/implicados?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaPretensionesImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getPretensionesVigentesImplicado = async(query) => {
    try {
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaProvisionesVigentes: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }
    } catch(error){
        throw error;
    }
}

export const getConfiguracionForm39 = async(query) => {
    try {
        
        const response = await client.getImplicado(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form39: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}